module.exports = __webpack_public_path__ + "static/media/ayanda_cele.fedd9ded.jpeg";